module.exports = __webpack_public_path__ + "img/verification-success.f16fd302.png";